import "./Hisn.css";
const img4 = require("../../imgs/Hisn/img104.jpg");
const img5 = require("../../imgs/Hisn/img105.jpg");
export default function Hisn() {
  return (
    <div className="HisnContainer">
      <div className="text_hisn">
        <div>
          <div>
            <h1>حِصْنٌ عَظِيمٌ جداً</h1>

            <div>
              <img className="imgyClass" src={img4} />
            </div>

            <h2>حِرْز مَانِعٌ وَتَحْصِين قُوَى </h2>
            <hr />
            <p>
              يَقْرَأَ قَبْلَ الْقِيَامِ بِأَىّ عَمِل ولِمَنْع الْإِنْسَانِ مِنْ
              شَرِّ جَمِيعِ الْخَلْقِ ، والأبالسه خَاصَّةً وَهُوَ ; بِسْمِ
              اللَّهِ الرَّحْمَنِ الرَّحِيمِ بِسْمِ اللَّهِ ياهوَ بِسْمِ اللَّهِ
              ياهوَ{" "}
            </p>
            <p>
              {" "}
              بِسْمِ اللَّهِ مَجْرَى السِّحْر هُوَ اللَّهُ يَا مَنْ أَلْجَمْت
              كُلِّ مُتَمَرِّدٍ سَلِّمْ سَلِّمْ ۩{" "}
            </p>
            <p>
              {" "}
              يَا اللَّهُ ذَنْبٌ لَا ذَنْبِى أَصْبَحُوا الْبَعِيد عَنَّا ،
              وَالْقَرِيبَ لَا يُؤْذِينَا ۩{" "}
            </p>
            <p>
              {" "}
              اللَّهُمَّ يَا سَابِل السَّتْر إذَا أَحَاطَت بنا الْبَلَاء ،
              وياسامع الْأَصْوَات مِنْ تَحْتِ العَلَاَ بِحَقّ نَبِيِّك
              الْمَحْبُوب ، وكرسيك الْمَنْصُوب أَن تَطْمَئِنّ قَلْب عَبْدَك
              الْخَائِف المرعوب مِن السُّيُوف إذَا سُلت ، وَمَن قُلُوب
              الْأَعْدَاء إذَا صَدت أَو اسْوَدَّت فَإِن جارو عَلَيْنَا فَرَدّهُم
              فَأَنْت رَبِّى ، وَرَبّ الْخَلَائِقَ كُلَّهُمْ دُسْتُور دُسْتُور ۩{" "}
            </p>
            <p>بِسْمِ اللَّهِ #سُؤْر ۩ </p>
            <p>
              {" "}
              ۞ اللَّهُ نُورُ السَّمَاوَاتِ وَالْأَرْضِ ۚ مَثَلُ نُورِهِ
              كَمِشْكَاةٍ فِيهَا مِصْبَاحٌ ۖ الْمِصْبَاحُ فِي زُجَاجَةٍ ۖ
              الزُّجَاجَةُ كَأَنَّهَا كَوْكَبٌ دُرِّيٌّ يُوقَدُ مِن شَجَرَةٍ
              مُّبَارَكَةٍ زَيْتُونَةٍ لَّا شَرْقِيَّةٍ وَلَا غَرْبِيَّةٍ
              يَكَادُ زَيْتُهَا يُضِيءُ وَلَوْ لَمْ تَمْسَسْهُ نَارٌ ۚ نُّورٌ
              عَلَىٰ نُورٍ ۗ يَهْدِي اللَّهُ لِنُورِهِ مَن يَشَاءُ ۚ وَيَضْرِبُ
              اللَّهُ الْأَمْثَالَ لِلنَّاسِ ۗ وَاللَّهُ بِكُلِّ شَيْءٍ عَلِيمٌ
              ۩{" "}
            </p>
            <p>وَآيَة الكرسى عَلَيْنَا تَدُور ۩ </p>
            <p>
              {" "}
              بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ اللَّهُ لَا إِلَٰهَ إِلَّا
              هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
              لَّهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَن ذَا الَّذِي
              يَشْفَعُ عِندَهُ إِلَّا بِإِذْنِهِ ۚ يَعْلَمُ مَا بَيْنَ
              أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِّنْ
              عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ
              وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ
              الْعَظِيمُ ۩{" "}
            </p>
            <p>
              {" "}
              ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ ۩{" "}
            </p>
            <p>
              ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ كَمَا
              دَار السُّؤْرُ عَلَى مَدِينَةِ الرَّسُولِ لَيْسَ لَهَا #قَفَل ،
              وَلَا #مِفْتَاح مِن الْمَسَاء حَتَّي الصَّبَّاح اللَّهُ أَكْبَرُ ۩{" "}
            </p>
            <p> اللَّهُ أَكْبَرُ ۩ </p>
            <p> اللَّهُ أَكْبَرُ ۩ </p>
            <p>
              {" "}
              عَلَى مَنْ طَغَى ، وَتُجْبَر بِسْمِ اللَّهِ ، وبأسمى وَلِلَّه جسمى
              ۩{" "}
            </p>
            <p>
              {" "}
              رَبَّنَا أحرصنى مِنْ طَوَارِقِ ، وَشَرّ الْجِنّ ، وَالْإِنْس ،
              وَالشَّيَاطِين ، وَالْوَحْش ، وَالْهَوَامّ ، والديب ،
              وَالْحَيَوَان ، وَكُلُّ مَا أَخَافُ ، وَاحْذَر لَا يَمَسُّ جسدى
              سِلَاح ، وَلَا جَرْح ، وَلَا شَيْطَانٌ لَهُ عِنْدَنَا #مِفْتَاح
              مِفْتَاحَهَا الْبَقَرَة بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ
              أَلَم ۩{" "}
            </p>
            <p>
              {" "}
              ذَٰلِكَ الْكِتَابُ لَا رَيْبَ ۛ فِيهِ ۛ هُدًى لِّلْمُتَّقِينَ ۩{" "}
            </p>
            <p>
              {" "}
              الَّذِينَ يُؤْمِنُونَ بِالْغَيْبِ وَيُقِيمُونَ الصَّلَاةَ وَمِمَّا
              رَزَقْنَاهُمْ يُنفِقُونَ ۩{" "}
            </p>
            <p>
              وَالَّذِينَ يُؤْمِنُونَ بِمَا أُنزِلَ إِلَيْكَ وَمَا أُنزِلَ مِن
              قَبْلِكَ وَبِالْآخِرَةِ هُمْ يُوقِنُونَ ۩{" "}
            </p>
            <p>
              {" "}
              أُولَٰئِكَ عَلَىٰ هُدًى مِّن رَّبِّهِمْ ۖ وَأُولَٰئِكَ هُمُ
              الْمُفْلِحُونَ ۩{" "}
            </p>
            <p> وَحِيطَانِهَا بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ يس ۩ </p>
            <p> وَالْقُرْآنِ الْحَكِيمِ ۩ </p>
            <p> إِنَّكَ لَمِنَ الْمُرْسَلِينَ ۩ </p>
            <p> عَلَى صِرَاطٍ مُسْتَقِيمٍ ۩ </p>
            <p> تَنْزِيلَ الْعَزِيزِ الرَّحِيمِ ۩ </p>
            <p>
              {" "}
              لِتُنْذِرَ قَوْمًا مَا أُنْذِرَ آبَاؤُهُمْ فَهُمْ غَافِلُونَ ۩{" "}
            </p>
            <p>
              {" "}
              لَقَدْ حَقَّ الْقَوْلُ عَلَى أَكْثَرِهِمْ فَهُمْ لَا يُؤْمِنُونَ ۩{" "}
            </p>

            <p>
              {" "}
              إِنَّا جَعَلْنَا فِي أَعْنَاقِهِمْ أَغْلَالًا فَهِيَ إِلَى
              الْأَذْقَانِ فَهُمْ مُقْمَحُونَ ۩{" "}
            </p>
            <p>
              {" "}
              وَجَعَلْنَا مِنْ بَيْنِ أَيْدِيهِمْ سَدًّا وَمِنْ خَلْفِهِمْ
              سَدًّا فَأَغْشَيْنَاهُمْ فَهُمْ لَا يُبْصِرُونَ ۩{" "}
            </p>
            <p>
              {" "}
              وَسَوَاءٌ عَلَيْهِمْ أَأَنْذَرْتَهُمْ أَمْ لَمْ تُنْذِرْهُمْ لَا
              يُؤْمِنُونَ ۩{" "}
            </p>
            <p>
              {" "}
              إِنَّمَا تُنْذِرُ مَنِ اتَّبَعَ الذِّكْرَ وَخَشِيَ الرَّحْمَنَ
              بِالْغَيْبِ فَبَشِّرْهُ بِمَغْفِرَةٍ وَأَجْرٍ كَرِيمٍ ۩{" "}
            </p>
            <p>
              {" "}
              إِنَّا نَحْنُ نُحْيِي الْمَوْتَى وَنَكْتُبُ مَا قَدَّمُوا
              وَآثَارَهُمْ وَكُلَّ شَيْءٍ أَحْصَيْنَاهُ فِي إِمَامٍ مُبِينٍ ۩{" "}
            </p>
            <p>
              {" "}
              وَقُوَّتِهَا أَلْفَ أَلْفِ لَا حَوْلَ ، وَلَا قُوَّةَ إلَّا
              بِاَللَّهِ الْعُلَى الْعَظِيم ۩{" "}
            </p>
            <p>
              {" "}
              بِسْمِ اللَّهِ أَذًى لَا يَضُرُّ مَعَ اسْمِهِ شَيْءٌ فِى الأَرْضِ
              ، وَلَا السَّمَاءَ ، وَهُوَ السَّمِيعُ الْعَلِيمُ ۩{" "}
            </p>
            <p>
              {" "}
              أَعُوذُ بِكَلِمَاتِ اللَّهِ التَّامَّاتِ مِنْ شَرِّ مَا خَلَقَ ۩{" "}
            </p>
            <p>
              {" "}
              بِسْمِ اللَّهِ الْخَالِقُ الْأَكْبَر ، وَهُو حِرْز مَانِع مِمَّا
              نَخَاف ، ونحذره لَا قُدْرَةَ لِمَخْلُوق مَعَ قُدْرَةٍ الْخَالِقِ
              الجمهُ بِلِجَام قُدْرَتِه ، وَكَانَ اللَّهُ قَوِيّا عَزِيزًا حُمّ
              عسق حمايتنا ۩{" "}
            </p>
            <p> كهيعص كفايتنا ۩ </p>
            <p> فَسَيَكْفِيكَهُمُ اللَّهُ وَهُوَ السَّمِيعُ الْعَلِيمُ ۩ </p>
            <p>
              {" "}
              سَتْر الْعَرْش مَسْبُول عَلَيْنَا ، وَعَيْنُ اللَّهِ نَاظِرُه
              إلَيْنَا ۩{" "}
            </p>
            <p>
              {" "}
              بِحَوْلِ اللَّهِ لَا يَقْدِرُو عَلَيْنَا ، وَاَللّهُ مِنْ ،
              وَرَائِهِم مُحِيط بَلْ هُوَ قُرْآنٌ مَجِيدٌ فِى لَوْحٍ مَحْفُوظٍ .
              ۩{" "}
            </p>
            <hr />
          </div>
          <div>
            <img className="imgyClass" src={img5} />
          </div>
        </div>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------------------------------------------------
